export const ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 40];
